import React from "react";
import {
  StackedCard,
  StackedLabel,
  StackedSub,
  ZoneCount,
  ZoneLine,
  ZoneSwatch,
  ZONE_LABELS,
} from "./styles";

const ORDEM_ZONAS = ["preto", "vermelho", "amarelo", "verde"];

export default function BufferStatusCard({ contagemPorZona }) {
  const total = ORDEM_ZONAS.reduce(
    (sum, zona) => sum + (contagemPorZona[zona] || 0),
    0
  );
  const semDado = contagemPorZona.semDado || 0;

  return (
    <StackedCard $tone="default" aria-label="Status de pulmões">
      <StackedLabel>Pulmões em produção</StackedLabel>
      {ORDEM_ZONAS.map((zona) => (
        <ZoneLine key={zona}>
          <ZoneSwatch $zone={zona} aria-hidden />
          <span>{ZONE_LABELS[zona]}</span>
          <span />
          <ZoneCount>{contagemPorZona[zona] || 0}</ZoneCount>
        </ZoneLine>
      ))}
      <StackedSub>
        Total considerado: {total}
        {semDado > 0 ? ` · ${semDado} sem aprovação/contrato` : ""}
      </StackedSub>
    </StackedCard>
  );
}
